import { BrandfolderHexColors } from '@brandfolder/react';
import classNames from 'classnames';
import { FunctionComponent, HTMLAttributes, ReactNode, useContext } from 'react';
import styled from 'styled-components';

import { PagesContext } from '@context/pages';
import { Page } from '@typings/page';

interface PagesDropzoneProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  page?: Page;
  pageKey?: string;
}

const UnstyledPagesDropzone: FunctionComponent<PagesDropzoneProps> = (props) => {
  const { children, page, pageKey, ...otherProps } = props;

  const { draggingPage, draggingSection } = useContext(PagesContext);

  const draggedPage = draggingPage && page && draggingPage.key !== page?.key;
  const draggedSection = draggingSection && !page && draggingSection.pageKey === pageKey;
  const dragging = draggedPage || draggedSection;

  return (
    <div
      {...otherProps}
      className={classNames({
        'pages-dropzone': true,
        'pages-dropzone--dragging': dragging,
        [`${otherProps?.className}`]: !!otherProps?.className
      })}
    >
      {children}
    </div>
  );
};

const StyledPagesDropzone = styled(UnstyledPagesDropzone)`
  outline-color: transparent;
  outline-offset: 0;
  outline-style: dashed;
  outline-width: 2px;

  &.pages-dropzone--dragging {
    outline-color: ${BrandfolderHexColors.PurplePopsicle};
  }
`;

export const PagesDropzone: FunctionComponent<PagesDropzoneProps> = (props) => {
  return <StyledPagesDropzone {...props} />;
};
